import React from 'react';
import { Menu, ActionIcon } from '@mantine/core';
import { IconDots, IconEdit, IconTrash, IconDoorExit } from '@tabler/icons-react'; // Import relevant icons
import { rem } from '@mantine/core'; // For consistent icon sizing

const IndividualSquadCard = ({
  squad,
  isOwned, // Boolean: true if current user owns this squad
  onEditClick, // Callback: (squad) => void
  onDeleteClick, // Callback: (squadId) => void
  onLeaveClick, // Callback: (squadId) => void
}) => {

  const handleEdit = () => {
    onEditClick(squad);
    // Menu automatically closes on item click, no need to setShowMenu(false)
  };

  const handleDelete = () => {
    if (window.confirm(`Are you sure you want to delete squad "${squad.name}"? This action cannot be undone.`)) {
      onDeleteClick(squad.id);
      // Menu automatically closes on item click
    }
  };

  const handleLeave = () => {
    if (window.confirm(`Are you sure you want to leave squad "${squad.name}"?`)) {
      onLeaveClick(squad.id);
      // Menu automatically closes on item click
    }
  };

  return (
    <div className="w-full relative bg-white border border-gray-200 rounded-lg shadow">
      {/* Menu Dots - Mantine Style */}
      <div className="flex justify-end px-4 pt-4">
        <Menu
          transitionProps={{ transition: "pop" }}
          withArrow
          position="bottom-end"
          withinPortal
        >
          <Menu.Target>
            <ActionIcon variant="subtle" color="gray">
              <IconDots
                style={{ width: rem(24), height: rem(24) }}
                stroke={1.8}
              />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            {isOwned && (
              <>
                <Menu.Item
                  onClick={handleEdit}
                  icon={
                    <IconEdit
                      style={{ width: rem(18), height: rem(18) }}
                      stroke={1.5}
                    />
                  }
                >
                  Edit Squad
                </Menu.Item>
                <Menu.Item
                  onClick={handleDelete}
                  color="red" // Mantine color for danger actions
                  icon={
                    <IconTrash
                      style={{ width: rem(18), height: rem(18) }}
                      stroke={1.5}
                    />
                  }
                >
                  Delete Squad
                </Menu.Item>
              </>
            )}
            {!isOwned && (
              <Menu.Item
                onClick={handleLeave}
                icon={
                  <IconDoorExit
                    style={{ width: rem(18), height: rem(18) }}
                    stroke={1.5}
                  />
                }
              >
                Leave Squad
              </Menu.Item>
            )}
          </Menu.Dropdown>
        </Menu>
      </div>

      <div className="flex flex-col gap-2 items-center pb-10 px-6">
        <h5 className="text-xl font-medium text-gray-900 text-center">
          {squad.name}
        </h5>
        <span className="text-sm text-gray-500 text-center ">
          {squad.description || 'No description provided.'}
        </span>

        {/* Member Avatars */}
        <div className="flex items-center justify-center">
          {squad.members && squad.members.slice(0, 4).map(member => (
            member.avatar_url ? (
              <img
                key={member.id}
                src={member.avatar_url}
                alt={`${member.first_name} ${member.last_name}`}
                className="w-8 h-8 rounded-full border-2 border-white -ml-2 first:ml-0 shadow-sm"
                title={`${member.first_name} ${member.last_name}`}
              />
            ) : (
              <div
                key={member.id}
                className="w-8 h-8 rounded-full border-2 border-white -ml-2 first:ml-0 shadow-sm bg-[#e5f2a2] text-[#717945] flex items-center justify-center text-xs font-bold"
                title={`${member.first_name} ${member.last_name}`}
              >
                {((member.first_name && member.first_name[0]) || "") +
                 ((member.last_name && member.last_name[0]) || "").toUpperCase()}
              </div>
            )
          ))}
          {squad.members && squad.members.length > 4 && (
            <span className="ml-2 text-sm text-gray-500">+{squad.members.length - 4} more</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default IndividualSquadCard;